<template>
    <div class="menu-div">
        <el-row>
            <draggable v-model="menus" :move="getdata" @update="datadragEnd">
                <transition-group>
                    <el-col :span="8" :offset="0" v-for="(menu,parentIndex) in menus"
                            :key="parentIndex">
                        <el-button type="primary" v-if="menu.name" @click="menuClick('parent', parentIndex)">
                            {{menu.name}}
                        </el-button>
                        <el-col v-for="(item,childrenIndex) in menu.sub_button" :key="childrenIndex">
                            <el-button @click="menuClick('children', parentIndex, childrenIndex)"
                                       :class="{elButtonFocus: !menusSelectStatus[parentIndex] ? false : menusSelectStatus[parentIndex][childrenIndex]}">
                                {{splice(item.name,parentIndex,childrenIndex)}}
                            </el-button>
                        </el-col>
                        <el-col :span="24" v-if="!menu.sub_button || menu.sub_button.length < 5">
                            <el-button icon="el-icon-plus"
                                       @click="add(parentIndex,!menu.sub_button? 0 : menu.sub_button.length)"/>
                        </el-col>
                    </el-col>
                </transition-group>
            </draggable>
            <el-col :span="8" :offset="0" v-if="menus.length < 3" :key="menus.length">
                <el-button icon="el-icon-plus" @click="add"/>
            </el-col>
        </el-row>
        <div class="setting" v-if="currentMenu.type !== ''">
            <div class="menu-setting-menu-div">
                <span class="menu-span">{{currentMenu.menu.name}}</span>
                <i class="el-icon-delete menu-delete" @click="del"></i>
            </div>
            <el-divider direction="horizontal"/>
            <div class="menu-setting-item">
                菜单名称:
                <el-input class="menu-name-input" v-model="currentMenu.menu.name" placeholder="请输入菜单名称"></el-input>
            </div>
            <div v-if="showMenuStatus()">
                <div class="menu-setting-item">
                    菜单内容:
                    <el-radio-group v-model="currentMenu.menu.type" @change="radioChange">
                        <el-radio label="media_id">发送图片</el-radio>
                        <el-radio label="view">跳转网页</el-radio>
                        <el-radio label="miniprogram">绑定微信小程序</el-radio>
                        <el-radio label="click">点击按钮回复</el-radio>
                    </el-radio-group>
                </div>
                <div class="menu-setting-item content">
                    <div v-if="currentMenu.menu.type === 'media_id'">
                        <el-button icon="el-icon-folder" @click="materials">从素材库选择</el-button>
                        <el-upload
                                action=""
                                class="upload-demo"
                                multiple
                                :show-file-list="false"
                                :on-success="uploadSuccess"
                                :http-request="uploadFile"
                                :limit="1">
                            <el-button icon="el-icon-picture">上传图片</el-button>
                        </el-upload>
                        <div class="media-id content">
                            media_id:
                            <el-input class="menu-name-input menu-setting-item-content"
                                      v-model="currentMenu.menu.media_id"
                                      placeholder="请输入media_id"></el-input>
                        </div>
                        <ImageShowDialog v-if="dialog.materialStatus" :show.sync="dialog.materialStatus"
                                         @itemClick="imageItemClick"/>
                    </div>
                    <div v-if="currentMenu.menu.type === 'view'">
                        网页链接：
                        <el-input class="menu-name-input menu-setting-item-content" v-model="currentMenu.menu.url"
                                  placeholder="请输入链接"></el-input>
                    </div>
                    <div v-if="currentMenu.menu.type === 'miniprogram'">
                        网页链接：
                        <el-input class="menu-name-input menu-setting-item-content" v-model="currentMenu.menu.url"
                                  :disabled="true"></el-input>
                        <br/>
                        小程序AppId：
                        <el-input class="menu-name-input menu-setting-item-content" v-model="currentMenu.menu.appid"
                                  placeholder="请输入小程序AppId"></el-input>
                        <br/>
                        小程序入口链接：
                        <el-input class="menu-name-input menu-setting-item-content" v-model="currentMenu.menu.pagepath"
                                  placeholder="例如:pages/lunar/index"></el-input>
                    </div>
                    <div v-if="currentMenu.menu.type === 'click'">
                        KEY：
                        <el-input class="menu-name-input menu-setting-item-content" v-model="currentMenu.menu.key"
                                  placeholder="请输入在点击回复中创建回复信息的事件KEY"></el-input>
                        <br/>
                    </div>
                </div>
            </div>
            <el-button class="submit-button" type="primary" @click="submit()">提交</el-button>
        </div>
        <div class="setting" v-if="!currentMenu.type">
            请在左侧选择或添加需要修改的按钮
        </div>
    </div>
</template>

<script>
    import ImageShowDialog from '../components/ImageShowDialog'
    import draggable from 'vuedraggable'

    export default {
        name: "MenuSetting",
        data() {
            return {
                radio: "media_id",
                menuNameInput: "",
                currentMenu: {
                    type: "",
                    parentIndex: "",
                    childrenIndex: "",
                    menu: {}
                },
                dialog: {
                    materialStatus: false
                },
                appId: "",
                menus: [],
                menusSelectStatus: [],
                tags: [0, 1, 2]
            }
        },
        components: {
            ImageShowDialog,
            draggable
        },
        mounted() {
            this.getMenus();
        },
        methods: {
            showMenuStatus() {
                return this.currentMenu.type === 'children'
                    || (this.currentMenu.type === 'parent'
                        && (!this.currentMenu.menu.sub_button
                            || this.currentMenu.menu.sub_button.length === 0));
            },
            splice(str, parentIndex, childrenIndex) {
                if (!this.menusSelectStatus[parentIndex]) {
                    this.menusSelectStatus[parentIndex] = [];
                }
                if (!this.menusSelectStatus[parentIndex][childrenIndex]) {
                    this.menusSelectStatus[parentIndex][childrenIndex] = false;
                }
                return this.$StringUtils.splice(str);
            },
            //添加按钮事件
            add(parentIndex, childrenIndex) {
                window.console.log("parentIndex = " + parentIndex + " childrenIndex = " + childrenIndex);
                if (childrenIndex === undefined) {
                    let currentParentMenu = {
                        name: "一级菜单名称"
                    };
                    this.menus.push(currentParentMenu);
                    return;
                }
                let subButton = this.menus[parentIndex].sub_button;
                window.console.log("subButton = " + subButton);
                if (subButton !== undefined) {
                    let currentChildrenMenu = {
                        name: "二级菜单名称"
                    };
                    let menu = {
                        name: this.menus[parentIndex].name,
                        sub_button: this.menus[parentIndex].sub_button
                    };
                    this.$set(this.menus, parentIndex, menu);
                    this.menus[parentIndex].sub_button.push(currentChildrenMenu);
                } else {
                    let sub_button = [{
                        name: "二级菜单名称"
                    }];
                    this.$set(this.menus[parentIndex], "sub_button", sub_button);
                    window.console.log(this.menus);
                }
            },
            //按钮删除事件
            del() {
                if (this.currentMenu.type === 'parent') {
                    this.menus.splice(this.currentMenu.parentIndex, 1);
                }
                if (this.currentMenu.type === 'children') {
                    window.console.log(this.currentMenu.childrenIndex);
                    if (this.currentMenu.childrenIndex === 0 && this.menus[this.currentMenu.parentIndex].sub_button.length === 1) {
                        this.$delete(this.menus[this.currentMenu.parentIndex], "sub_button");
                    } else {
                        this.menus[this.currentMenu.parentIndex].sub_button.splice(this.currentMenu.childrenIndex, 1);
                    }
                }
                this.currentMenu.type = '';
                if (this.currentMenu.parentIndex && this.currentMenu.childrenIndex) {
                    this.menusSelectStatus[this.currentMenu.parentIndex][this.currentMenu.childrenIndex] = false;
                }
            },
            //按钮点击事件
            menuClick(menuType, parentIndex, childrenIndex) {
                this.currentMenu.type = menuType;
                this.currentMenu.parentIndex = parentIndex;
                this.currentMenu.childrenIndex = childrenIndex;
                let parentLength = this.menusSelectStatus.length;

                for (let i = 0; i < parentLength; i++) {
                    if (!this.menusSelectStatus[i]) {
                        continue;
                    }
                    for (let j = 0; j < this.menusSelectStatus[i].length; j++) {
                        this.menusSelectStatus[i][j] = false;
                    }
                }
                if (menuType === "parent") {
                    this.currentMenu.menu = this.menus[parentIndex];
                    window.console.log(this.currentMenu);
                }
                if (menuType === "children") {
                    this.currentMenu.menu = this.menus[parentIndex].sub_button[childrenIndex];
                    this.menusSelectStatus[parentIndex][childrenIndex] = true;
                }
                this.radio = this.currentMenu.menu.type;
                window.console.log("currentMenu");
                window.console.log(this.currentMenu);
            },
            materials() {
                this.dialog.materialStatus = !this.dialog.materialStatus;
            },
            uploadSuccess() {
                this.$message({
                    message: '文件上传成功',
                    type: 'success'
                })
            },
            uploadFile(fileInfo) {
                let param = new FormData();
                param.append('file', fileInfo.file);
                this.$api.material.addMaterial(param).then(data => {
                    fileInfo.onSuccess(data);
                });
            },
            getMenus() {
                this.$api.menu.getMenus().then(data => {
                    if (data.data.menu) {
                        this.menus = data.data.menu.button;
                    }
                });
            },
            radioChange(radioType) {
                window.console.log(radioType);
                this.currentMenu.menu.type = radioType;
                if (radioType === "miniprogram") {
                    this.$set(this.currentMenu.menu, "url", "http://mp.weixin.qq.com");
                }
            },
            imageItemClick(item) {
                this.currentMenu.menu.media_id = item.media_id;
                this.dialog.materialStatus = false;
            },
            submit() {
                for (let menu of this.menus) {
                    if (menu.sub_button && menu.sub_button.length > 0) {
                        for (let button of menu.sub_button) {
                            if (!button.type) {
                                this.$message({
                                    showClose: true,
                                    message: "请设置二级菜单",
                                    type: "error"
                                });
                                return;
                            }
                        }
                    } else {
                        if (!menu.type) {
                            this.$message({
                                showClose: true,
                                message: "请设置一级菜单",
                                type: "error"
                            });
                            return;
                        }
                    }
                }
                this.$confirm("是否提交更新按钮操作?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$api.menu.createMenu(this.menus).then(() => {
                        this.$message({
                            message: "提交成功",
                            type: "success"
                        });
                    });
                });
            },
            getdata(evt) {
                window.console.log(evt.draggedContext.element.id)
                window.console.log(this.tags);
            },
            datadragEnd(evt) {
                window.console.log('拖动前的索引 :' + evt.oldIndex)
                window.console.log('拖动后的索引 :' + evt.newIndex)
                window.console.log(this.tags)
                // this.$set(this.menus, evt.oldIndex, oldMenu);
                // this.$set(this.menus, 1, oldMenu);
                // this.$set(this.menus, 2, newMenu);
                window.console.log(this.menus)
            }
        }
    }
</script>

<style scoped>
    .el-row {
        width: 450px;
        float: left;
        margin-left: 0;
    }

    .menu-div {
        padding-top: 10px;
        width: 1000px;
        margin-left: 20px;
        margin-top: 20px;
    }

    .el-row .el-button {
        width: 140px;
        height: 40px;
    }

    .setting {
        float: left;
        margin-left: 25px;
        width: 505px;
        text-align: left;
        padding: 20px 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .setting .el-divider--horizontal {
        margin: 10px 0;
    }

    .menu-name-input {
        width: 350px;
    }

    .menu-setting-item {
        margin: 15px 0;
    }

    .menu-setting-item-content {
        margin: 10px 0;
    }

    .content {
        border: 1px solid #DCDFE6;
        border-radius: 2px;
        padding: 20px 10px;
    }

    .menu-delete {
        float: right;
        margin-right: 10px;
    }

    .menu-span {
        height: 25px;
        display: inline-block;
    }

    .menu-setting-menu-div {
        height: 25px;
    }

    .upload-demo {
        width: 120px;
        display: inline-block;
        margin-left: 10px;
    }

    .elButtonFocus {
        color: #409EFF;
        border-color: #c6e2ff;
        box-shadow: inset 0 3px 5px 0 rgba(0, 0, 0, 0.2);
    }

    .media-id {
        margin-top: 10px;
    }

    .media-id > span {
        color: #409EFF;
    }

    .submit-button {
        float: right;
    }

</style>